var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDb = function SvgDb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 49 47"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "M33.84 23.697h7.636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Db_svg__a)",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "M47.82 21.12h-5.953v5.951h5.952V21.12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Db_svg__b)",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "M47.82 8.62h-5.953v5.951h5.952V8.62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Db_svg__c)",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "M47.82 33.62h-5.953v5.951h5.952V33.62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "M34.094 11.596h7.383M34.094 36.594h7.383"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    fillRule: "evenodd",
    d: "M33.439 29.48V39.963c0 3.335-7.26 6.039-16.216 6.039-8.955 0-16.215-2.704-16.215-6.04V29.482",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "M33.439 29.48V39.963c0 3.335-7.26 6.039-16.216 6.039-8.955 0-16.215-2.704-16.215-6.04V29.482"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    fillRule: "evenodd",
    d: "M33.439 18.518v10.481c0 3.335-7.26 6.039-16.216 6.039-8.955 0-16.215-2.704-16.215-6.04V18.519",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "M33.439 18.518v10.481c0 3.335-7.26 6.039-16.216 6.039-8.955 0-16.215-2.704-16.215-6.04V18.519"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    fillRule: "evenodd",
    d: "M33.439 7.512v10.481c0 3.335-7.26 6.039-16.216 6.039-8.955 0-16.215-2.704-16.215-6.04V7.513",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "M33.439 7.512v10.481c0 3.335-7.26 6.039-16.216 6.039-8.955 0-16.215-2.704-16.215-6.04V7.513"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "M17.215 13.078c8.956 0 16.216-2.703 16.216-6.039C33.43 3.704 26.17 1 17.215 1 8.26 1 1 3.704 1 7.04c0 3.334 7.26 6.038 16.215 6.038"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Db_svg__a",
    x1: 41.867,
    x2: 47.819,
    y1: 21.119,
    y2: 27.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Db_svg__b",
    x1: 41.867,
    x2: 47.819,
    y1: 8.619,
    y2: 14.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Db_svg__c",
    x1: 41.867,
    x2: 47.819,
    y1: 33.619,
    y2: 39.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
};
export default SvgDb;